import type { CSSProperties } from 'react';
import type { SxProps, Theme } from '@mui/material';
import { Avatar as AvatarMui, Box, Typography } from '@mui/material';
import { type Profile } from 'api';
import { ConditionalLoader } from 'dashboard409a/pages/Operations/components';
import { getInitials } from 'utilities/getInitials';
import { AvatarContainer } from './Avatar.styles';

interface AvatarProps {
  data?: Profile[];
  name: string;
  roleTitle: string;
  isLoading?: boolean;
  sx?: SxProps<Theme>;
  style?: CSSProperties;
}

const Avatar = ({ data = [], name, roleTitle, isLoading, sx, style }: AvatarProps) => (
  <AvatarContainer>
    {data.length > 1 ? (
      <Box display="flex" flexDirection="column" gap={0.5}>
        {data.map(item => (
          <AvatarMui
            key={item.id}
            alt={name}
            src={item.picture_url ?? ''}
            sx={{ width: 32, height: 32, fontSize: '1rem', ...sx }}
            style={style}
          >
            {getInitials({ name: `${item.first_name} ${item.last_name}` })}
          </AvatarMui>
        ))}
      </Box>
    ) : (
      <AvatarMui
        alt={name}
        src={data?.[0]?.picture_url ?? ''}
        sx={{ width: 32, height: 32, fontSize: '1rem', ...sx }}
        style={style}
      >
        {getInitials({ name })}
      </AvatarMui>
    )}
    <Box>
      <ConditionalLoader isLoading={isLoading} width={150} height={16}>
        <Typography fontWeight="bold" fontSize="0.8rem">{name}</Typography>
      </ConditionalLoader>
      <ConditionalLoader isLoading={isLoading} width={100} height={14}>
        <Typography fontSize="0.75rem" color="text.secondary">
          {roleTitle}
        </Typography>
      </ConditionalLoader>
    </Box>
  </AvatarContainer>
);

export default Avatar;
